import React, { PureComponent, ReactElement } from 'react';
import Select from 'react-select';
import { SideBarProps } from '../types';
import { SelectedKrets } from '../catalog/krets-actions';
import { decorateOrganizer, getQueryParameter, kretsSorter, parseValues } from '../utils';

interface KretsSidebarState {
  selected: SelectedKrets[];
}

export default class KretsSidebar extends PureComponent<SideBarProps, KretsSidebarState> {
  constructor(props: SideBarProps) {
    super(props);
    this.state = {
      selected: parseValues(getQueryParameter('krets'), props.organizers),
    };
  }
  select = (selected: SelectedKrets[] = []): void => {
    if (selected === null) {
      selected = [];
    }
    this.props.fetchActivities({
      organizer: selected.map((o) => o.value),
    });
    this.setState({ selected });
  };
  componentDidMount(): void {
    this.select(this.state.selected);
  }

  render(): ReactElement {
    const organizers = [].concat(this.props.organizers).filter((o) => o.type !== 'Nämnd');
    organizers.sort(kretsSorter);
    return (
      <div className="contextual-region block block-sidebar-first">
        <div className="block-title">
          <h3>
            <span className="disable-select">Arrangör</span>
          </h3>
        </div>

        <div className="block-content-outer">
          <div className="block-content">
            <Select
              isClearable
              isMulti
              onChange={this.select}
              value={decorateOrganizer(this.state.selected, organizers)}
              options={organizers.map((item) => ({
                label: item.name,
                value: item.id,
              }))}
              placeholder="Välj krets"
              menuPlacement="top"
            />
          </div>
        </div>
      </div>
    );
  }
}
